import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/faqs")({
  component: React.lazy(() =>
    import("@/pages/information/faqs").then((mod) => ({
      default: mod.FAQsPage,
    })),
  ),
});
